import LoadingState from 'components/common/LoadingState';
import ErrorState from 'components/common/ErrorState';
import { renderComponent, branch } from 'recompose'; // see: https://www.apollographql.com/docs/react/recipes/recompose.html
import React from 'react';

const renderWhileLoading = (component = LoadingState, propName = 'data') => branch(
  props => props[propName]
      && props[propName].loading
      && props[propName].networkStatus !== 6,
  renderComponent(component),
);

const renderWhenErrored = (
  ErrorComponent = ErrorState,
  propName = 'data',
  title,
  message,
) => branch(
  props => props[propName] && props[propName].error,
  renderComponent(props => (
    <ErrorComponent {...props} title={title} message={message} />
  )),
);

export default {
  errorHOC: ({
    propName, component, title, message,
  }) => renderWhenErrored(component, propName, title, message),
  loadingHOC: ({ propName, component }) => renderWhileLoading(component, propName),
};



// WEBPACK FOOTER //
// ./src/lib/helpers/RecomposeHelpers/index.js